$(document).ready(function() {
    // Carousel for testimonials
    $('.sp-testimonials-container').slick({
        centerMode: true,
        centerPadding: '1.25rem',
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        slidesToShow: 2,
        slidesToScroll: 2
    });
});